import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "none",
    paddingTop: theme.spacing(2),
  },
}));

const CustomModal = (props) => {
  const classes = useStyles();

  return (
    <Modal
      className={classes.modal}
      open={props.open}
      onClose={props.close}
      closeAfterTransition
      ref={props.modalRef}
    >
      <div
        style={{
          // display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          maxWidth: '60%',
        }}
      >
        <div className={classes.paper}>{props.children}</div>
      </div>
    </Modal>
  );
};

export default CustomModal;
